import React from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  MenuItem,
  Stack,
  TextField,
  Typography,
  Chip,
} from "@mui/material";

const DOC_TYPE_LABELS = {
  ine: "INE / Identificación oficial",
  curp: "CURP",
  acta_nacimiento: "Acta de nacimiento",
  estado_cuenta: "Estado de cuenta",
  comprobante_domicilio: "Comprobante de domicilio",
  rfc_constancia: "Constancia RFC",
  nomina: "Nómina",
  otro: "Otro",
};

function cleanValue(value) {
  if (value === null || value === undefined) return "";
  return `${value}`;
}

export default function DocumentRecognitionModal({
  open,
  item,
  documentType,
  onChangeDocumentType,
  selectedDocumentFieldId,
  onChangeDocumentField,
  documentFieldOptions = [],
  extractedData = {},
  onChangeExtractedData,
  onCancel,
  onConfirm,
  processing,
}) {
  if (!item) return null;

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="md">
      <DialogTitle>Confirmar datos reconocidos</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Alert severity="info">
            Archivo: <b>{item?.file?.name || "Documento"}</b>
          </Alert>

          <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
            <TextField
              select
              label="Tipo detectado"
              fullWidth
              value={documentType || "otro"}
              onChange={(event) => onChangeDocumentType?.(event.target.value)}
            >
              {Object.entries(DOC_TYPE_LABELS).map(([key, label]) => (
                <MenuItem key={key} value={key}>
                  {label}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              label="Campo documental destino"
              fullWidth
              value={selectedDocumentFieldId || ""}
              onChange={(event) => onChangeDocumentField?.(event.target.value)}
              helperText="Se guardará como si se hubiera cargado en este campo."
            >
              {documentFieldOptions.length === 0 && (
                <MenuItem value="" disabled>
                  No hay campo compatible en schema
                </MenuItem>
              )}
              {documentFieldOptions.map((field) => (
                <MenuItem key={field.id} value={field.id}>
                  {field?.vc_label || field?.vc_nombre || field?.id}
                  {field?._process_name
                    ? ` | ${field._process_name}`
                    : ""}
                </MenuItem>
              ))}
            </TextField>
          </Stack>

          <Divider />

          <Typography variant="subtitle2">Datos extraídos</Typography>
          <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
            {Object.entries(extractedData)
              .filter(
                ([key, value]) =>
                  key !== "raw_excerpt" &&
                  value !== null &&
                  value !== undefined &&
                  `${value}`.trim() !== "",
              )
              .map(([key]) => (
                <Chip key={key} label={key} size="small" />
              ))}
          </Stack>

          <Stack spacing={1}>
            {Object.entries(extractedData)
              .filter(([key]) => key !== "raw_excerpt")
              .map(([key, value]) => (
                <TextField
                  key={key}
                  label={key}
                  fullWidth
                  value={cleanValue(value)}
                  onChange={(event) =>
                    onChangeExtractedData?.(key, event.target.value)
                  }
                />
              ))}
          </Stack>

          {extractedData?.raw_excerpt && (
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                OCR (resumen)
              </Typography>
              <Box
                component="pre"
                sx={{
                  m: 0,
                  p: 1.5,
                  borderRadius: 1,
                  maxHeight: 220,
                  overflow: "auto",
                  bgcolor: "rgba(0,0,0,0.04)",
                  fontSize: 12,
                }}
              >
                {extractedData.raw_excerpt}
              </Box>
            </Box>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={processing}>
          Omitir
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={processing || !selectedDocumentFieldId}
        >
          {processing ? "Guardando..." : "Confirmar y guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
